import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-text">
          <h1>Welcome to Instilit.com:<br />Revolutionizing Your Job Search</h1>
          <p>
            Discover the power of AI in your career journey. Instil-it combines cutting-edge artificial intelligence 
            with intuitive job search tools to help you land your dream job faster and smarter than ever before.
          </p>
          {/* <div className="hero-buttons">
            <a href="/free-trial" className="btn-primary">Start Your Free Trial</a>
            <a href="/how-it-works" className="btn-secondary">See How It Works</a>
          </div> */}
        </div>
        <div className="hero-image">
          <img src="/images/about1.png" alt="AI-powered Job Search" />
        </div>
      </section>

   {/* Mission Section */}
<section className="mission-section">
  <div className="mission-image">
    <img src="/images/about2.png" alt="Empowering Job Seekers with AI" />
  </div>
  
  <div className="mission-content">
    <h2>Our Mission: Empowering Job Seekers with AI</h2>

    <div className="mission-point">
      <span className="mission-number">1</span>
      <div className="mission-text">
        <h3>Democratizing Career Opportunities</h3>
        <p>
          We believe everyone deserves access to powerful job search tools.
          Our AI-driven platform levels the playing field, giving all job seekers
          the same advantages previously available only to those with insider connections.
        </p>
      </div>
    </div>

   {/* Our Mission Section */}
    <div className="mission-point">
      <span className="mission-number">2</span>
      <div className="mission-text">
        <h3>Eliminating Job Search Frustration</h3>
        <p>
          The traditional job application process is broken. We’re rebuilding it 
          from the ground up, eliminating tedious applications, reducing waiting time, 
          and providing real-time feedback to make your job search efficient and effective.
        </p>
      </div>
    </div>

    <div className="mission-point">
      <span className="mission-number">3</span>
      <div className="mission-text">
        <h3>Continuous Innovation</h3>
        <p>
          Our team of AI specialists and career experts constantly refine our algorithms 
          to ensure you stay ahead of changing job market trends, application techniques, 
          and interview practices.
        </p>
      </div>
    </div>
  </div>
</section>


      {/* What We Offer Section */}
      <section className="offer-section">
        <h2>What We Offer</h2>
        <div className="offer-cards">
          <div className="offer-card">
            <img src="/images/about3.png" alt="FutureTech Training" />
            <Link to="/futuretech-training">
  <h4>FutureTech Training</h4>
</Link>
            <p>AI, ML, Blockchain, and more — master tomorrow's skills today.</p>
          </div>
          <div className="offer-card">
            <img src="/images/about4.png" alt="Smart Resume Analysis" />
            <Link to="/resume-analysis">
            <h4>Smart Resume Analysis</h4>
            </Link>
            <p>Get AI-backed insights to optimize your resume for top roles.</p>
          </div>
          <div className="offer-card">
            <img src="/images/about5.png" alt="Trainers Hub" />
            <Link to="/freelancer-trainer">
            <h4>Trainers Hub</h4>
            </Link>
            <p>Join Trainers Hub today and showcase your skills to thousands.</p>
          </div>
          {/* <div className="offer-card">
            <img src="/images/about6.png" alt="Oracle Applications" />
            <Link to= "/oracle-qe-automation">
            <h4>Oracle QE Applications</h4>
            </Link>
            <p>Robust solutions and training for modern enterprises.</p>
          </div> */}
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <h2>Join Our Journey of Innovation</h2>
        <p>Connect with us to unlock your potential and step into the future.</p>
        <div className="cta-buttons">
          {/* <a href="/contact" className="btn-primary">Contact Us</a> */}
          <Link to="/contact#contact-us" className="btn-primary">Contact Us</Link>

          <a href="/Login" className="btn-secondary">Join Now</a>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
